<template>
<div>
		<b-row>
			<b-col md="12" class="mb-4">
				<h6>Null</h6>
				<language-selectbox v-model="value1"/>
				<span>{{ value1 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Single Selected</h6>
				<language-selectbox v-model="value2"/>
				<span>{{ value2 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Multiple Selected</h6>
				<language-selectbox v-model="value3" :multiple="true"/>
				<span>{{ value3 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Validate Error</h6>
				<language-selectbox v-model="value4" :validate-error="value4ValidateError"/>
				<span>{{ value4 }}</span>
			</b-col>
			<b-col cols="12">
				<b-button variant="primary" @click="change()">
					{{ $t('change') }}
				</b-button>
			</b-col>
		</b-row>
	</div>
</template>
<script>
	import LanguageSelectbox from "@/components/interactive-fields/LanguageSelectbox";

	export default {
		components: {
			LanguageSelectbox,
		},
		data() {
			return {
				value1: null,
				value2: 'TR',
				value3: 'TR,EN',
				value4: 'TR',
				value4ValidateError: 'Validate Error is Working',
			}
		},
		methods: {
			change() {
				this.value2 = 'EN'
				this.value3 = 'EN'
				this.value4 = 'EN'
				this.value4ValidateError = 'Error'
			}
		}
	};
</script>

